export const useHistoryMessages = (
  historyChatFile?: MaybeRefOrGetter<string | undefined>,
  videoTime?: MaybeRefOrGetter<number | undefined>,
) => {
  const { data: historyMessages } = useQuery({
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: () => !!toValue(historyChatFile),
    queryKey: ['history-messages', historyChatFile],
    queryFn: async ({ signal }) => {
      const data = await fetch(toValue(historyChatFile)!, {
        method: 'GET',
        signal,
      }).then((res) => res.json())
      return data as HistoryRtmMessage[]
    },
  })

  const add = (channel: string, startedAt: number, message: RtmMessage) => {
    const now = dayjs()
    const recordedTime = now.diff(dayjs(startedAt))
    return db.historyMessages.add({
      channel,
      recordedTime,
      ...message,
    })
  }

  const getByChannel = (channel: string) => {
    return db.historyMessages.where('channel').equals(channel).toArray()
  }

  const deleteByChannel = (channel: string) => {
    return db.historyMessages.where('channel').equals(channel).delete()
  }

  const deleteOthers = (channel: string) => {
    return db.historyMessages.where('channel').notEqual(channel).delete()
  }

  const data = computed(() => {
    return (
      historyMessages.value?.filter(
        (message) => message.recordedTime <= (toValue(videoTime) ?? 0),
      ) ?? []
    )
  })

  return {
    data,
    add,
    getByChannel,
    deleteByChannel,
    deleteOthers,
  }
}
